module.exports = __webpack_public_path__ + "img/mi-moet-ik-naar-de-dokter.735d0cd0.svg";